<mat-toolbar class="app-footer">
  <span class="spacer"></span>
  <pp-version-button />
</mat-toolbar>
